export default __webpack_public_path__ + "static/media/storelocator-banner.d5136d07.jpg";